<div class="register-page flex flex-column md:flex-row">
  <!-- Desktop sidebar -->
  <div class="hidden md:block p-2">
    <div class="flex flex-column justify-content-between p-4 sidebar h-full">
      <div>
        <div class="logo">
          <img
            class="logo-image"
            src="/images/header_logo.svg"
            width="96"
            height="44"
            alt="Full Scale Solutions"
          />
        </div>
        <div class="mt-4 flex flex-column gap-3">
          @for (step of steps; track step.value; let last = $last) {
            <div class="flex align-items-start gap-2">
              <div class="flex flex-column align-items-center">
                @if (activeStep > step.value) {
                  <app-step-success width="1.3rem" height="1.3rem"></app-step-success>
                } @else if (activeStep === step.value) {
                  <p-badge [value]="step.value" severity="secondary" [dt]="badgeStyle"></p-badge>
                } @else {
                  <p-badge class="opacity-60" [value]="step.value" severity="secondary" [dt]="inactiveBadgeStyle"></p-badge>
                }

                @if (!last) {
                  <svg width="2" height="32" viewBox="0 0 2 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.6" d="M1 1L1 31" stroke="#E1E2E6" stroke-width="2" stroke-linecap="round"
                          stroke-dasharray="0.1 6" />
                  </svg>
                }
              </div>

              <div class="flex flex-column">
                @if (activeStep === step.value) {
                  <div class="text-sm-semibold text-gray-700">{{ step.title }}</div>
                  <div class="text-sm-regular text-gray-600">{{ step.subtitle }}</div>
                } @else if (activeStep > step.value) {
                  <div class="text-sm-semibold text-gray-700">{{ step.title }}</div>
                  <div class="text-sm-regular text-gray-600">{{ step.subtitle }}</div>
                } @else {
                  <div class="text-sm-semibold text-gray-700 opacity-60">{{ step.title }}</div>
                  <div class="text-sm-regular text-gray-600 opacity-60">{{ step.subtitle }}</div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <div class="text-sm-regular text-gray-600">
        © Full Scale Solutions {{ currentYear }}
      </div>
    </div>
  </div>

  <!-- Mobile header -->
  <div class="flex md:hidden flex-column p-3">
    <div class="flex align-items-center justify-content-between">
      <img
        class="nav-logo"
        src="/images/header_logo.svg"
        alt="Full Scale Solutions"
      />
      <div class="flex align-items-center white-space-nowrap">
        <div class="text-sm-regular text-gray-600">Već imate nalog?</div>
        <div class="ml-1 text-sm-semibold text-gray-700 cursor-pointer" (click)="location.routeToLogin()">Prijavite se</div>
      </div>
    </div>
    <div class="mt-3 flex align-items-center gap-2 mobile-steps">
      @for (step of steps; track step.value; let last = $last) {
        <div class="mobile-step-bar" [class.active]="activeStep === step.value"
             [class.completed]="activeStep > step.value"></div>
      }
    </div>
    <div class="mt-2 text-sm-semibold text-gray-700">Korak {{ activeStep }} od {{ steps.length }}: {{ steps[activeStep - 1].title }}</div>
  </div>

  <!-- Mobile: the whole page scrolls as one; desktop keeps the fixed sidebar and scrolls only the form -->
  <div class="register-main flex-1 flex flex-column">
    <div class="hidden md:flex align-items-center justify-content-end p-5">
      <div class="text-sm-regular text-gray-600">Već imate nalog?</div>
      <div class="ml-1 text-sm-semibold text-gray-700 cursor-pointer" (click)="location.routeToLogin()">Prijavite se</div>
    </div>
    <div class="register-scroll flex-1">
      <div class="content-container">
        @switch (activeStep) {
          @case (1) {
            <app-register-step-1
              [form]="form"
              [isValid]="isStepValid(1)"
              (next)="next()"
            />
          }
          @case (2) {
            <app-register-step-2
              [form]="form"
              [isLegalEntity]="form.controls.isLegalEntity!.value!"
              [isValid]="isStepValid(2)"
              (next)="next()"
              (back)="back()"
            />
          }
          @case (3) {
            <app-register-step-3
              [form]="form"
              [isValid]="isStepValid(3)"
              (back)="back()"
              (submit)="submit()"
            />
          }
        }
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="isConfirmationDialogVisible"
          [focusOnShow]="false"
          [modal]="true"
          [closable]="false"
          [style]="{ width: '30rem', maxWidth: 'calc(100vw - 2rem)' }">
  <div class="welcome-dialog flex flex-column align-items-center">
    <div class="flex justify-content-center align-items-center icon">
      <app-check-circle stroke="#067647" width="20px" height="20px"></app-check-circle>
    </div>
    <div class="mt-3 text-lg-semibold text-gray-900">
      Dobrodošli, {{ form.value.firstName }}!
    </div>
    <div class="mt-1 text-sm-regular text-gray-600 text-center">
      Vaš nalog je uspešno kreiran. Nakon prijave možete kupiti paket i zakazati termin.
    </div>
    <div class="mt-4 flex align-items-center justify-content-between gap-3 success-dialog-info-container">
      @if (form.value.isLegalEntity) {
        <div class="flex align-items-center">
          <div class="success-dialog-info-icon">
            <app-building-05 stroke="#181D27"></app-building-05>
          </div>
          <div class="ml-2-5 flex flex-column">
            <div class="text-sm-semibold text-gray-900">{{ form.value.companyName }}</div>
            <div class="mt-1 text-sm-regular text-gray-600">{{ form.value.firstName + ' ' + form.value.lastName }}</div>
          </div>
        </div>
        <p-chip label="Pravno lice" class="white sm"></p-chip>
      } @else {
        <div class="flex align-items-center">
          <div class="success-dialog-info-icon">
            <app-user-circle stroke="#181D27"></app-user-circle>
          </div>
          <div class="ml-2-5 text-sm-semibold text-gray-900">
            {{ form.value.firstName + ' ' + form.value.lastName }}
          </div>
        </div>  
        <p-chip label="Fizičko lice" class="white sm"></p-chip>
      }
    </div>
    <!-- Two equal-width buttons, so the footer is as symmetric as the centred content above -->
    <div class="mt-5 welcome-dialog__actions w-full">
      <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="buyPackage()">
        <div class="text-sm-semibold text-gray-900">Kupite paket</div>
      </app-button>
      <app-button [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="location.routeToLogin()">
        <div class="text-sm-semibold text-white">U redu</div>
      </app-button>
    </div>
  </div>
</p-dialog>
